export default ({ axios }) => ({
    update: (good_id, property_id, body) => axios.patch(`/goods/${good_id}/properties/${property_id}`, body)
})



// WEBPACK FOOTER //
// ./src/api/goodProperties.js